export const cleanFeatureFlags = (flags: string[] | null | undefined): string[] => {
  return flags?.map(flag => flag.trim()).filter(flag => flag.length > 0) ?? [];
};
